import { createTRPCReact } from '@trpc/react-query';
import { httpBatchLink } from '@trpc/client';
import { QueryClient } from '@tanstack/react-query';
import type { AppRouter } from '@cade/api-gateway/src/router';
import { emitUnauthorized } from './auth-events';

export const trpc = createTRPCReact<AppRouter>();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000 },
  },
});

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: '/trpc',
      headers: () => {
        const token = localStorage.getItem('cade_token');
        return token ? { Authorization: `Bearer ${token}` } : {};
      },
      fetch: (url, options) =>
        globalThis.fetch(url, options).then((response) => {
          if (response.status === 401) {
            emitUnauthorized();
          }
          return response;
        }),
    }),
  ],
});
